<div class="header header-checkout prs-checkout-header" data-testing-id="prs-checkout-header">
  <!-- Match storefront portal chrome: soft utility strip + white brand bar (not navy checkout bar) -->
  <div class="prs-checkout-header__utility">
    <div class="container prs-header-inner prs-checkout-header__utility-row">
      <span class="prs-checkout-header__eyebrow">{{ 'shell.portal.eyebrow' | translate }}</span>
      <div class="prs-checkout-header__utility-links">
        <a class="prs-checkout-header__utility-link" routerLink="/contact-team" data-testing-id="checkout-contact-team">
          {{ 'shell.portal.contact_team' | translate }}
        </a>
        <a class="prs-checkout-header__utility-link" routerLink="/help-center" data-testing-id="checkout-help-center">
          {{ 'shell.portal.help_center' | translate }}
        </a>
      </div>
    </div>
  </div>
  <div class="prs-checkout-header__bar">
    <div class="container prs-checkout-header__inner">
      <div class="prs-checkout-header__brand">
        <a
          class="prs-checkout-header__logo"
          data-testing-id="header-home-link-desktop"
          rel="home"
          routerLink="/home"
          [attr.aria-label]="'common.home.link' | translate"
        ></a>
        <span class="prs-checkout-header__divider" aria-hidden="true"></span>
        <span class="prs-checkout-header__product">MyPresidio</span>
      </div>
      <div class="prs-checkout-header__secure" data-testing-id="prs-checkout-secure">
        <i class="bi bi-lock-fill" aria-hidden="true"></i>
        <span>{{ 'checkout.secure.heading' | translate }}</span>
      </div>
      <a
        routerLink="/basket"
        class="prs-checkout-header__cart"
        data-testing-id="prs-checkout-back-cart"
        [attr.aria-label]="'shopping_cart.ministatus.label' | translate: { '0': (itemCount$ | async) || 0 }"
      >
        <span class="prs-checkout-header__cart-icon">
          <i class="icon-shopping-bag" aria-hidden="true"></i>
          <span class="prs-checkout-header__cart-count" aria-hidden="true">{{ itemCount$ | async }}</span>
        </span>
        <span class="prs-checkout-header__cart-label">{{ 'shell.portal.cart' | translate }}</span>
      </a>
    </div>
  </div>
</div>
